// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Vth4D","footer":"styles_footer__3u_1i"};